import { defineStore } from 'pinia';
import { getInfo, logout } from '@/api/modules/user';
import { LocalStorageService } from '@/utils/storage';
import { formatDate } from '@/utils/index';
import watermark from '@/utils/watermark'

type State = {
  userInfo: TypeObject,
  menus: TypeObject[],
  authKeys: string[],
  menuKeys: string[]
}
export const useUserStore = defineStore('_user', {
  state: (): State => ({
    userInfo: {},
    menus: [],
    authKeys: [],
    menuKeys: []
  }),
  actions: {
    getUserInfo(): Promise<TypeObject> {
      return new Promise((resolve, reject) => {
        getInfo().then(({ data }: TypeObject) => {
          const { oa, username, roles , shouldShowPopup, headPortrait } = data;
          let operations = data.functions?.component || [];
          let menus = data.functions?.menu || [];
          //  首页隐藏
          let index = menus.findIndex((item:any) => item.name === '首页')
          if (index > -1){
            menus.splice(index,1)
          }
          if (!oa) { // 无用户信息
            this.setUserInfo({}); // 设置用户信息

            resolve({ menus: [], authKeys: [], menuKeys: [] });
          } else {
            // 获取所有的authKeys，包括组件下面配置的操作
            this.menus = menus;
            this.authKeys = operations.map((func: TypeObject) => func.name);
            this.menuKeys = menus = menus.map((menu: TypeObject) => menu.name);
            // 设置水印
            watermark.update({
              // 需要传递password
              password: '1234',
              text: [
                `${oa}`,
                `${formatDate(Date.now(), 'YYYY-MM-DD')}`
              ],
            })
            // 增加 满意度调查问卷
            console.log((window as any).MaiaAppraisal)
            const obj = {
              appKey: "f6a6b6e93d6a472f9b4a97c3a4e384ef",
              oaAccount: oa,     //b端产品传入
              clientType: "",
              bottom: 20,
              position:'leftbottom',
              color: "blue",
              debug: false
            }
            ;(window as any)?.MaiaAppraisal?.appraisal(obj)

            this.setUserInfo({
              oa,
              username,
              roles,
              shouldShowPopup,
              headPortrait,// 头像
              authKeys: this.authKeys,
            });
            window.zhuge.identify(data.oa, {
              名称: data.userName,
              OA: data.oa,
              角色: data.roles,
            },()=> {
              resolve({
                menus,
                authKeys: this.authKeys,
                menuKeys: this.menuKeys,
              });
            });

            // window.zhuge.setSuperProperty({
            //   名称: data.userName,
            //   OA: data.oa,
            //   角色: data.roles,
            // });

          }
        }).catch(() => {
          resolve({
            menus: [],
            authKeys: [],
            menuKeys: []
          });
          reject(new Error('获取用户权限信息失败'));
        });
      });
    },

    logout(): void {
      this.userInfo = {};
      this.menus = [];
      this.authKeys = [];
      this.menuKeys = [];

      LocalStorageService.clear();

      const isProd = window.location.host.indexOf('idata.longfor.com') >= 0;
      const logoutHost = isProd
        ? 'https://sso.longfor.com/cas/new/logout'
        : 'https://sso-uat.longfor.com/cas/logout';
      const logoutQuery = `loginType=mixLogin&redirectUrl=${encodeURIComponent(window.location.origin)}&sysCode=XM2242301`;
      const logoutUrl = `${logoutHost}?${logoutQuery}`;

      window.location.href = logoutUrl;
    },
    setUserInfo(info: TypeObject) {
      this.userInfo = info;
      LocalStorageService.set('_user_info', info);
    },
    setUserShowPopup(value: Boolean) {
      this.userInfo.shouldShowPopup = value;
    },
  },
});
